@if (discountDetailsTooltip) {
  <span [raUiTooltip]="discountDetailsTooltip" [tooltipConfig]="tooltipConfig">
    {{ tokenActivity }}
  </span>
} @else {
  <span>
    {{ tokenActivity }}
  </span>
}
